import React, { lazy } from 'react';
import DynamicSkeletonGrid from '../../../../skeleton_loaders/common/DynamicSkeletonGrid.jsx';
import withSuspense from '../../../../helpers/withSuspense.jsx';

const MapWidget = withSuspense(lazy(() => import('./MapWidget.jsx')), <DynamicSkeletonGrid colSizes={['20%', '50%', '30%']} rowSizes={['100%']} width='calc(100% - 2rem)' />);

export default MapWidget;